var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,_vm._g({tag:"component",attrs:{"title":_vm.title,"links":_vm.formattedLinks}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }